module.exports = __webpack_public_path__ + "static/media/keyboard-arrow-right-black-48-dp.21f135a5.svg";